export default __webpack_public_path__ + "static/media/kavida_logo.848a742a.webp";